<template>
  <div class="riesgo">
    <div>
      <h4>{{ $t('DATOS DEL RIESGO') }}</h4>
      <el-form @keydown.native.enter.prevent>
        <el-row :gutter="20">
          <el-col :span="14">
            <el-form-item :label="$t('Nombre del Riesgo o Aspecto ambiental')">
              <br />
              {{risk.nombre}}
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item :label="$t('Tipo de Impacto')">
              <br />
              {{MaysPrimera(risk.tipo)}}
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div>
      <hr class="separacion" />
      <div>
        <el-row :gutter="30">
          <el-col :md="14">
            <el-col :md="24" v-if="risk.escenario !== ''">
              <br />
              <h4 class="margin-title">{{ $t('ESCENARIO') }}</h4>
              <p>{{ risk.escenario || $t('No ingresado')}}</p>
              <br />
              <br />
            </el-col>
            <el-col :md="12">
              <br />
              <h4 class="margin-title">{{$t('PELIGRO')}}</h4>
              <p>{{ risk.peligro || $t('No ingresado')}}</p>
              <br />
              <br />
            </el-col>
            <el-col :md="12">
              <br />
              <h4 class="margin-title">{{$t('ENERGÍA')}}</h4>
              <p>{{ risk.energia || $t('No ingresado')}}</p>
              <br />
              <br />
            </el-col>
          </el-col>
          <el-col :md="10">
            <br />
            <h4 class="margin-title">{{$t('EVENTO NO DESEADO')}}</h4>
            <p>{{ risk.evento_no_deseado || $t('No ingresado')}}</p>
            <br />
            <br />
          </el-col>
          <el-col :md="10">
            <br />
            <h4
              class="left margin-title"
            >{{ $t('PERSONAS QUE PARTICIPAN EN EL ANÁLISIS DEL RIESGO') }}</h4>
            <el-table
              :data="risk.evaluadores"
              :key="componentKey"
              row-class-name="rowClassTablaPloma"
              header-cell-class-name="header-cell-class-table-gray-2"
            >
              <el-table-column :label="$t('Nombre')" prop="nombre"></el-table-column>
              <el-table-column :label="$t('RUT')" prop="rut"></el-table-column>
              <el-table-column :label="$t('Cargo')" prop="cargo" />
            </el-table>
            <br />
          </el-col>
          <el-col :md="4">
            <br />
            <center>
              <h4 class="align-center">{{$t('IR SIN CONTROLES')}}</h4>
              <span style="font-size: 27px;">
                <b>{{risk.sin_controles ? (risk.sin_controles.severidad * risk.sin_controles.probabilidad) : 0}}</b>
              </span>
            </center>
          </el-col>
          <el-col :md="10">
            <br />
            <h4 class="left margin-title">{{ $t('SIN CONTROLES') }}</h4>
            <br />
            <br />
            <br />
            <el-form label-position="top" :inline="true">
              <el-form-item label="Ingrese severidad" style="margin-right: 40px;">
                <center>
                  <span style="font-size: 27px;">
                    <b>{{risk.sin_controles.severidad}}</b>
                  </span>
                </center>
              </el-form-item>
              <el-form-item label="Ingrese probabilidad" style="margin-right: 40px;">
                <center>
                  <span style="font-size: 27px;">
                    <b>{{risk.sin_controles.probabilidad}}</b>
                  </span>
                </center>
              </el-form-item>
              <el-form-item label="Indice de riesgo">
                <center>
                  <span style="font-size: 27px;">
                    <b>{{risk.sin_controles.severidad * risk.sin_controles.probabilidad}}</b>
                  </span>
                </center>
              </el-form-item>
            </el-form>
          </el-col>
        </el-row>
      </div>
      <hr class="separacion" />
      <div class="box-card">
        <el-row :gutter="20">
          <!-- Causas -->
          <el-col :md="10">
            <br />
            <h4 class="left margin-title">
              {{$t('CAUSAS')}}
              <el-popover
                class="help-box"
                placement="top"
                :title="$t('Causas')"
                width="200"
                trigger="hover"
                :content="$t('Las causas son las circunstancias que pueden gatillar la ocurrencia del evento.')"
              >
                <i slot="reference" class="el-icon-question" />
              </el-popover>
            </h4>
            <el-table
              :data="risk.causas"
              style="width: 100%"
              :key="componentKey"
              row-class-name="rowClassTablaPloma"
              header-cell-class-name="header-cell-class-table-gray-2"
            >
              <el-table-column prop="id" label="ID" width="80">
                <template slot-scope="scope">CA{{ risk.causas.indexOf(scope.row) + 1 }}</template>
              </el-table-column>
              <el-table-column prop="nombre" :label="$t('Nombre')" />
            </el-table>
            <br />
          </el-col>
          <!-- Riesgo -->
          <el-col :md="4">
            <!-- COLORES
              Material rojo
              No material amarillo
            Custom celeste-->
            <!-- Riesgo Material creado por MEL desde admin -->
            <div
              v-if="risk.tipo && risk.tipo.toLowerCase() === 'salud'"
              class="colorSalud customRiskBox"
            >{{ risk.nombre === '' ? 'Sin nombre': risk.nombre }}</div>
            <!-- Riesgo No Material creado por MEL desde admin -->
            <div
              v-if="risk.tipo && risk.tipo.toLowerCase() === 'seguridad'"
              class="colorSeguridad customRiskBox"
            >{{ risk.nombre === '' ? 'Sin nombre': risk.nombre }}</div>
            <!-- Riesgo Personalizado -->
            <div
              v-if="risk.tipo && (risk.tipo.toLowerCase() === 'medioambiental' || risk.tipo.toLowerCase() === 'medioambiente')"
              class="colorMedioambiental customRiskBox"
            >{{ risk.nombre === '' ? 'Sin nombre': risk.nombre }}</div>
            <!-- Riesgo Sin tipo -->
            <div
              v-if="risk.tipo === null"
              class="colorWithoutRisk customRiskBox"
            >{{ risk.nombre === '' ? 'Sin nombre': risk.nombre }}</div>
          </el-col>
          <!-- Impactos -->
          <el-col :md="10">
            <br />
            <h4 class="left margin-title">
              {{$t('IMPACTOS')}}
              <el-popover
                class="help-box"
                placement="top"
                :title="$t('Impactos')"
                width="200"
                trigger="hover"
                :content="$t(`Nivel de severidad cuando el evento ocurre.`)"
              >
                <i slot="reference" class="el-icon-question" />
              </el-popover>
            </h4>
            <el-table
              :data="risk.impactos"
              style="width: 100%"
              row-class-name="rowClassTablaPloma"
              header-cell-class-name="header-cell-class-table-gray-2"
            >
              <el-table-column prop="id" label="ID" width="80">
                <template slot-scope="scope">IM{{ risk.impactos.indexOf(scope.row) + 1 }}</template>
              </el-table-column>
              <el-table-column prop="tipo" :label="$t('Tipo')" />
              <el-table-column :label="$t('Descripción')">
                <template
                  slot-scope="scope"
                >{{ scope.row.descripcion.substring(0, 80) || "" }} [...]</template>
              </el-table-column>
              <el-table-column prop="mfl" label="MFL" width="50" />
            </el-table>
            <br />
          </el-col>
        </el-row>
      </div>
      <div>
        <el-row :gutter="20">
          <!-- Controles Preventivos -->
          <el-col :md="10">
            <hr />
            <br />
            <h4 class="left margin-title">
              {{ $t('CONTROLES PREVENTIVOS') }}
              <el-popover
                class="help-box"
                placement="top"
                :title="$t('Controles Preventivos')"
                width="200"
                trigger="hover"
                :content="$t(`Los controles preventivos son los que se
                    utilizan para enfrentarse a las causas, por lo que reducen
                    la probabilidad de que ocurran riesgos.`)"
              >
                <i slot="reference" class="el-icon-question" />
              </el-popover>
            </h4>
            <el-table
              row-class-name="rowClassTablaPloma"
              header-cell-class-name="header-cell-class-table-gray-2"
              :key="componentKey"
              :data="getControlesPreventivos(risk)"
              style="width: 100%"
            >
              <el-table-column prop="nombre" :label="$t('Nombre')" />
              <el-table-column prop="id_causa" :label="$t('Causa')" width="90">
                <template slot-scope="scope">
                  <div
                    v-for="causaHumanID in scope.row.causasHumanID"
                    :key="causaHumanID"
                  >{{ causaHumanID }}</div>
                </template>
              </el-table-column>
            </el-table>
          </el-col>
          <!-- Factores -->
          <el-col :md="4">
            <br />
            <br />
            <br />
            <center>
              <h4 class="align-center">{{$t('IR CON CONTROLES')}}</h4>
              <span style="font-size: 27px;">
                <b>{{risk.con_controles ? (risk.con_controles.severidad * risk.con_controles.probabilidad) : 0}}</b>
              </span>
            </center>
          </el-col>
          <!-- Controles Mitigadores -->
          <el-col :md="10">
            <hr />
            <br />
            <h4 class="left margin-title">
              {{$t('CONTROLES MITIGADORES')}}
              <el-popover
                class="help-box"
                placement="top"
                title="Controles Mitigadores"
                width="200"
                trigger="hover"
                :content="$t(`Los controles de mitigación son aquellos que
                    reducen los impactos derivados de un riesgo.`)"
              >
                <i slot="reference" class="el-icon-question" />
              </el-popover>
            </h4>
            <el-table
              row-class-name="rowClassTablaPloma"
              header-cell-class-name="header-cell-class-table-gray-2"
              :data="getControlesMitigadores(risk)"
              style="width: 100%"
            >
              <el-table-column prop="nombre" :label="$t('Nombre')" />
              <el-table-column prop="id_impacto" :label="$t('Impacto')" width="90" />
            </el-table>
          </el-col>
        </el-row>
        <el-row>
          <el-col :md="10">
            <br />
            <br />
            <h4 class="margin-title">
              {{$t('CONTROL ADICIONAL')}}
              <el-popover
                class="help-box"
                placement="top"
                :title="$t('Control adicional')"
                width="200"
                trigger="hover"
                :content="$t(`En construcción.`)"
              >
                <i slot="reference" class="el-icon-question"></i>
              </el-popover>
            </h4>
            <p>{{ risk.evento_no_deseado || $t('No ingresado')}}</p>
            <br />
            <br />
          </el-col>
          <el-col :md="10" :offset="4">
            <br />
            <br />
            <h4 class="left margin-title">{{ $t('CON CONTROLES') }}</h4>
            <br />
            <br />
            <br />
            <el-form label-position="top" :inline="true">
              <el-form-item label="Ingrese severidad" style="margin-right: 40px;">
                <center>
                  <span style="font-size: 27px;">
                    <b>{{risk.con_controles.severidad}}</b>
                  </span>
                </center>
              </el-form-item>
              <el-form-item label="Ingrese probabilidad" style="margin-right: 40px;">
                <center>
                  <span style="font-size: 27px;">
                    <b>{{risk.con_controles.probabilidad}}</b>
                  </span>
                </center>
              </el-form-item>
              <el-form-item label="Indice de riesgo" style="margin-right: 40px;">
                <center>
                  <span style="font-size: 27px;">
                    <b>{{risk.con_controles.severidad * risk.con_controles.probabilidad}}</b>
                  </span>
                </center>
              </el-form-item>
            </el-form>
          </el-col>
        </el-row>
      </div>
    </div>
  </div>
</template>

<script>
import { clone } from "lodash";
import Vue from "vue";
import TablaSeveridad from "./TablaSeveridad.vue";
import uuid from "uuid/v4";
import TablaProbabilidad from "./TablaProbabilidad.vue";
import axios from "axios";

export default {
  data() {
    return {
      typeRisk: ""
    };
  },
  components: {
    TablaSeveridad,
    TablaProbabilidad
  },
  props: ["risk"],
  created() {
    this.typeRisk = this.risk.tipo;
  },
  methods: {
    MaysPrimera(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    },
    getControlesPreventivos(risk) {
      const controlesIndicator = {};
      if (risk.causas) {
        risk.causas.forEach((causa, index) => {
          const humanID = `CA${index + 1}`;
          if (causa.controles_preventivos) {
            causa.controles_preventivos.forEach(control => {
              if (!controlesIndicator[control.nombre]) {
                controlesIndicator[control.nombre] = {};
                controlesIndicator[control.nombre].critico = control.critico;
                controlesIndicator[control.nombre].id = control.id;
                controlesIndicator[control.nombre].jerarquiaControl =
                  control.jerarquiaControl;
              }
              if (!controlesIndicator[control.nombre].causasHumanID) {
                controlesIndicator[control.nombre].causasHumanID = [];
                controlesIndicator[control.nombre].causasID = [];
              }
              controlesIndicator[control.nombre].causasHumanID.push(humanID);
              controlesIndicator[control.nombre].causasID.push(causa.id);
            });
          }
        });
      }
      const controles = Object.keys(controlesIndicator).map(key => ({
        causasHumanID: controlesIndicator[key].causasHumanID,
        causasID: controlesIndicator[key].causasID,
        nombre: key,
        critico: controlesIndicator[key].critico,
        id: controlesIndicator[key].id,
        jerarquiaControl: controlesIndicator[key].jerarquiaControl
      }));
      return controles;
    },
    getControlesMitigadores(risk) {
      const controles = [];
      if (risk.impactos) {
        risk.impactos.forEach((impacto, index) => {
          const id = `IM${index + 1}`;
          if (impacto.controles_mitigadores) {
            impacto.controles_mitigadores.forEach(control => {
              control.id_impacto = id;
              control.impactoId = impacto.id;
              controles.push(control);
            });
          }
        });
      }
      return controles;
    },
    getFactores(risk) {
      let mfl = 0;
      let rrr = 0;
      if (risk.impactos) {
        risk.impactos.forEach(impacto => {
          if (impacto.mfl > mfl) {
            ({ mfl } = impacto);
            rrr =
              (impacto.factor_severidad *
                10 *
                (impacto.factor_probabilidad * 10)) /
              (10 * 10);
          }
        });
      }
      return [
        {
          mfl,
          rrr
        }
      ];
    },
    mflRange(mfl) {
      if (mfl >= 4) {
        return "danger";
      }
      if (mfl === 3) {
        return "warning";
      }
      return "gray";
    }
  }
};
</script>

<style scoped>
.btn-bowtie {
  margin-top: 10px;
}
h4 {
  font-weight: bold;
}
label {
  text-transform: uppercase;
  font-weight: bold;
  color: gray;
  font-size: 11px;
}
.info-txt {
  margin-top: 5px;
  color: #e65400;
}
.factores {
  font-size: 20px;
}
.align-right {
  text-align: right;
}
.align-center {
  text-align: center;
}
.button-add {
  width: 200px;
  background-color: #ee890bba !important;
  border: none;
  color: white;
}
.button-add:hover {
  width: 200px;
  background-color: #ee890b !important;
  border: none;
  color: white;
}

.button-skip {
  margin-left: 10px;
  width: 110px;
  background-color: #ee890bba !important;
  border: none;
  color: white;
}
.derecha {
  float: right;
}
.izquierda {
  float: left;
}
.margin-title {
  margin-top: 0px;
}
.groupLabel {
  font-size: 15px;
  font-weight: bold;
  margin-left: 19px;
}
</style>
